import * as Yup from 'yup';
import { l10nEnService } from '@uplift/services';

export const useLoginValidationSchema = (l10n: typeof l10nEnService) => {
  return Yup.object().shape({
    username: Yup.string()
      .required(l10n.validations.loginForm.emailBlank)
      .test('has-at', l10n.validations.loginForm.noAt, value => value?.includes('@') ?? false)
      .email(l10n.validations.loginForm.noDomain),
    password: Yup.string()
      .min(8, l10n.validations.tooShort)
      .max(50, l10n.validations.tooLong)
      .required(l10n.validations.loginForm.passwordBlank),
  });
};
